import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((Theme) => ({
  mobileCalendar: {
    width: '100%',
    height: '100%',
    position: 'absolute',
  },
  datepickerHeaderFixed: {
    position: 'fixed',
    width: '100%',
    height: '193px',
  },
  actionsFixed: {
    position: 'fixed',
    width: '100%',
    height: '90px',
    bottom: 0,
    backgroundColor: '#FFF',
  },
  rootDatepickerMobile: {
    position: 'fixed',
    width: '100%',
    height: 'calc(100% - 297px)',
    top: '200px',
    overflowY: 'auto',
    [Theme.breakpoints.up('xs')]: {
      top: '200px',
      height: 'calc(100% - 300px)',
    },
    [Theme.breakpoints.up('md')]: {
      top: '210px',
      height: 'calc(100% - 310px)',
    },
  },
  datepickerHeader: {
    padding: Theme.spacing(2, 4),
    [Theme.breakpoints.up('xs')]: {
      'padding-left': '20px',
      'padding-right': '20px',
      paddingTop: Theme.typography.size[4],
      paddingBottom: '0',
    },
    [Theme.breakpoints.up('md')]: {
      'padding-left': '50px',
      'padding-right': '50px',
      paddingTop: Theme.typography.size[7],
      paddingBottom: '0',
    },
  },
  datepickerHeaderItem: {
    width: '100%',
  },
  datepickerHeaderFix: {
    position: 'fixed',
    width: '100%',
  },
  datepickerHeaderLabel: {
    marginBottom: '2px !important',
    color: '#FFF !important',
  },
  wrapDatepickerMobile: {
    position: 'relative',
    overflow: 'inherit !important',
    backgroundColor: '#FFFFFF',
    borderRadius: '0 !important',
    boxShadow: '0px 2px 4px 0 rgba(6,21,86,0.15)',
  },
  datepickerHeaderMobileBtn: {
    display: 'flex',
    'justify-content': 'flex-end',
  },
  mobileButtons: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
    paddingRight: Theme.typography.size[4],
    [Theme.breakpoints.down('md')]: {
      '& button': {
        height: '50px',
      },
    },
    [Theme.breakpoints.up('xs')]: {
      'padding-right': '20px',
      paddingTop: Theme.typography.size[4],
      paddingBottom: Theme.typography.size[4],
    },
    [Theme.breakpoints.up('md')]: {
      'padding-right': '50px',
      paddingTop: Theme.typography.size[6],
      paddingBottom: Theme.typography.size[6],
      '& button': {
        height: '40px',
      },
    },
  },
  mobileButtonsGroup: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
  },
  resetButton: {
    textTransform: 'capitalize',
    color: Theme.palette.primary.light,
    letterSpacing: 'inherit',
    fontSize: Theme.typography.size[1],
    maxWidth: '104px',
  },
  doneButton: {
    minWidth: 104,
    width: 'auto',
    '&.MuiButton-containedPrimary': {
      marginLeft: '0',
    },
    [Theme.breakpoints.up('md')]: {
      minWidth: 95,
      maxHeight: 40,
    },
  },
  resetButtonMobile: {
    textTransform: 'capitalize',
    padding: '0 !important',
    color: Theme.palette.primary.light,
    letterSpacing: 'inherit',
    fontSize: '16px !important',
    width: 'auto',
    minWidth: '0',
    marginRight: Theme.typography.size[10],
    [Theme.breakpoints.up('md')]: {
      paddingTop: Theme.typography.size[6],
      paddingBottom: Theme.typography.size[6],
      maxHeight: '40px',
    },
  },
  datepickerMessages: {
    display: 'flex',
    justifyContent: 'flex-end',
    fontFamily: Theme.typography.base.regular,
    fontSize: '14px',
    lineHeight: '17px',
    padding: '20px 20px 20px 20px',
    color: Theme.palette.gray[750],
    [Theme.breakpoints.up('xs')]: {
      padding: '20px 20px 20px 20px',
    },
    [Theme.breakpoints.up('md')]: {
      padding: '20px 50px 20px 50px',
    },
  },
  underscore: {
    width: Theme.typography.size[4],
    height: Theme.typography.pxToRem(3),
    background: '#061556',
    borderRadius: '10px',
    marginLeft: Theme.typography.pxToRem(7.5),
    marginRight: '8px',
    marginTop: '7px',
  },
  datepickerCalendar: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '30px',
  },
}));

export default useStyles;
